import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Select from 'react-select';


const modeloDatos = {
   movimientoAlmacenID: 0, 
    empresaID: "PR",
    almacenID:1,
    suplidorID:1,
   tipoTransaccionID:0,
    descripcion: "",
    comentario: "",
    cerrado: false,
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date,
    itbisIncluido: 0, 
    rnc: "",
    ncf:"",
    itbis: 0.00,
    subTotal: 0.00,
    total: 0.00,
    formaPago:1

}
const modeloDatosArt = {
   movimientoAlmacenID: 0, 
    articuloID: "PR",
    cantidad: 0,
    costoPromedio: 0.00,
    movimiento:"",
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date,
   
}
let movimiento = "";
let options1 = [];
let options2 = [];
let Precio = 0.00;
const MovimientoAlmacen = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [tablaArt, setTablaArt] = useState(modeloDatosArt);
    const [Listado, SetListado] = useState([]);
    const [ListadoSuplidor, SetListadoSuplidor] = useState([]);
    const [ListadoLineas, SetListadoLineas] = useState([]);
    const [ListadoArticulos, SetListadoArticulos] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [ver, setVer] = useState(true);
    const [ListadoTransaccion, SetListadoTransaccion] = useState([]);
    const [Listado1, SetListado1] = useState([]);
    const [busqueda, setbusqueda] = useState("");
    const [ListadoAlmacen, SetListadoAlmacen] = useState([]);
    const [user, setUser] = useState([window.localStorage.getItem("sesion_usuario")])
    const [margen, Setmargen] = useState(1.00);
    let use = JSON.parse(user);

    const handleChange = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: e.target.value
        })
    }
    const handleChange4 = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            ["suplidorID"]: e.value
        })
    }
    const handleChange1 = (e) => {


        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTablaArt({
            ...tablaArt,
            [e.target.name]: e.target.value
        })
    }
    const handleChange2 = (e) => {
        var va = e.target.value;
        va = parseFloat(va);
        if (e.target.name == 'costoPromedio') {
            setTablaArt({
                ...tablaArt,
                [e.target.name]: va
            });

            (tabla.itbisIncluido) ? Precio = ((va * parseFloat(margen - 18) / 100) + va)
                : Precio = ((va * parseFloat(margen) / 100) + va)
        } else {
            (tabla.itbisIncluido) ? Precio = (((va - 18) * parseFloat(tablaArt.costoPromedio) / 100) + tablaArt.costoPromedio)
           : Precio = ((va * parseFloat(tablaArt.costoPromedio) / 100) + tablaArt.costoPromedio)
            Setmargen(va)
        }



    }

    const handleChange3 = (e) => {
        (tabla.itbisIncluido) ? Precio=((e.costoPromedio * (e.margen / 100)) + e.costoPromedio) : Precio=((e.costoPromedio * (e.margen / 100)) + e.costoPromedio)
        if (e.margen == null) { Setmargen(1) } else { Setmargen(e.margen) }
        setTablaArt({
            ...tablaArt,
            ["articuloID"]: e.value, ["nombreArticulo"]: e.label, ["costoPromedio"]: e.costoPromedio
        })
    }

    const onChange = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);
        console.log(e);
        var searchData = l.filter((item) => {
            if (
                (item.descripcion)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };

    const obtenerDatosAlmacen = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaAlmacen");

        if (response.ok) {
            let data = await response.json()
            SetListadoAlmacen(data)

        }
    }
    const obtenerDatos = async () => {
        let response = await fetch(Api + "VentasTrans/listaMovimientoAlmacen");

        if (response.ok) {
            let data = await response.json()
            SetListado1(data)
            if (pendiente) {
                SetListado(data)
            }
            setPendiente(false)
        }
    }
    const obtenerDatosLineas = async (w) => {
        let response = await fetch(Api + "VentasTrans/listaMovimientoAlmacenLineas/" + w);

        if (response.ok) {
            let data = await response.json()
            SetListadoLineas(data)
        }
    }

    const EliminarLinea = async (w) => {
        let response = await fetch(Api + "VentasTrans/EliminarMovimientoAlmacenLineas/" + w);

        if (response.ok) {
            let data = await response.json()
            obtenerDatosLineas(data.movimientoID)
        }
    }


    const obtenerDatosArticulas = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaArticulos/" + use.correo);

        if (response.ok) {
            let data = await response.json()
            SetListadoArticulos(data)
            data.filter(x => x.activo == true && x.tipoArticulo == 0).map(x => {
                options1.push({ value: x.articuloID, label: x.codigoAuxiliar + "-" + x.descripcion, Cant_min: x.cantidadMinima, costoPromedio: x.costoPromedio, margen: x.margen })
            })
        }
    }
    //const obtenerTipoTransaccionPedido = async () => {
    //    let response = await fetch(Api + "VentasMantenimiento/ListaTipoTransaccionPedido");

    //    if (response.ok) {
    //        let data = await response.json()
    //        SetListadoTransaccion(data)

    //    }
    //}
    useEffect(() => {
        obtenerDatos();
    }, [tabla.movimientoAlmacenID])

        useEffect(() => {
       
        //obtenerTipoTransaccionPedido();
        obtenerDatosArticulas();
        obtenerDatosAlmacen();
        obtenerDatosSuplidor();
    },[])
    
    const obtenerDatosSuplidor = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaSuplidor");

        if (response.ok) {
            options2=[]
            let data = await response.json()
            SetListadoSuplidor(data)
            data.map(x => {
                options2.push({ value: x.suplidorID, label:  x.descripcion })
            })
        }
    }

    const AgregarArticulo = async () => {

        tablaArt.cantidad = tablaArt.cantidad * (movimiento + 1)
        let response = await fetch(Api + "VentasTrans/AgregarArticuloAlmacen/" + tablaArt.movimientoAlmacenID + "/" + tablaArt.articuloID +
            "/" + tablaArt.cantidad + "/" + parseFloat(tablaArt.costoPromedio)+"/"+Precio);

        //if (response.ok) {
        //    let data = await response.json()
        //    SetListado(data)
        //    setPendiente(false)
        //}
/*        setTablaArt(modeloDatosArt)*/
        obtenerDatosLineas(tablaArt.movimientoAlmacenID)
        tablaArt.cantidad = 0;
        Setmargen(1.00)
        Precio=0.00
    }
    const guardarCambios = async () => {
      
        setPendiente(!pendiente)
        let response;
        tabla.itbis = parseFloat(tabla.itbis)
        tabla.subTotal = parseFloat(tabla.subTotal)
        tabla.total = parseFloat(tabla.total)
        tabla.formaPago = parseInt(tabla.formaPago)
        if (tabla.movimientoAlmacenID == 0) {
          
            response = await fetch(Api + "VentasTrans/GuardarMovimientoAlmacen", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

        } else {
            response = await fetch(Api + "VentasTrans/EditarPregunta", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
            let data = await response.json()
            obtenerDatos();
            
            tabla.movimientoAlmacenID = data.movimientoAlmacenID;
            movimiento = ListadoTransaccion.filter(x => x.tipoTransID == data.tipoTransaccionID).map(x => x.movimiento);
            obtenerDatosLineas(data.movimientoAlmacenID)
            setTablaArt(data);
            setVer(false)
            
           
         
        //    setVerModal(!verModal);
           
        } else {
            alert("error al guardar")
        }
        
        obtenerDatos();
    }

    const cerrarmovimiento = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea cerrar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {

                const response = fetch(Api + "VentasTrans/cerrarmovimiento/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {

                            obtenerDatos();

                            Swal.fire(
                                'Cerrado!',
                                'El producto fue cerrado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data, v) => {
        setVer(v);
        setTabla(data);
        movimiento = ListadoTransaccion.filter(x => x.tipoTransID == data.tipoTransaccionID).map(x => x.movimiento);
        obtenerDatosLineas(data.movimientoAlmacenID)
     
        setTablaArt(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.movimientoAlmacenID,
            sortable: true,
        },
        {
            name: 'Suplidor',
            selector: row => (ListadoSuplidor.filter(x=>x.suplidorID == row.suplidorID).map(s => s.descripcion)),
            sortable: true,
        },{
            name: 'Descripcion',
            selector: row => row.descripcion,
            sortable: true,
        },
    
        {
            name: '',
            cell: row => (
                <>
                    <i hidden={row.cerrado == 0}>Cerrado</i>
                    <div hidden={row.cerrado == 1}>
                    <Button color="primary" size="sm" className="mr-2"
                     onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>

                    <Button color="danger" size="sm"
                            onClick={() => cerrarmovimiento(row.movimientoAlmacenID)}
                    >
                            <i className="fas fa-lock"></i>
                        </Button></div>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row, true)}
                    >
                        <i className="fas fa-eye"></i>
                    </Button>
                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Movimientos de articulos en el Almacen
                </CardHeader>
                <CardBody>
                    <Row><Col md={2}>    <Button color="success" size="sm"
                    onClick={() => setVerModal(!verModal)}
                    >Nuevo Movimiento</Button>
                </Col>
                <Col md={4}>    <Input type="search" name="busqueda" onChange={(e) => onChange(e)} placeholder="Buscar  " ></Input> </Col>
            </Row>  
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                      progressPending={pendiente}
                       pagination
                      paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal className="modal-preguntas" isOpen={verModal}>
                <ModalHeader className="modal-header1">
                  
                    <div class="box">
                        <div>   Movimiento de articulo en Almacen </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Suplidor</Label>
                                {/*<Input bsSize="sm" type={"select"} name="suplidorID" onChange={handleChange} value={tabla.suplidorID} className="form-control"  >*/}
                                {/*     <option value={0}>Seleccionar</option>*/}
                                {/*    {*/}
                                {/*       ListadoSuplidor.map((item) => (<option key={item.suplidorID} value={item.suplidorID}>{item.descripcion}</option>))*/}
                                {/*    }*/}
                                {/*</Input>*/}
                                <Select
                                    name={"suplidorID"}
                                    defaultValue={options2.filter(x => x.value == tabla.suplidorID)[0]}
                                    onChange={handleChange4}
                                    options={options2}
                                />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Orden o Pedido</Label>
                                <Input bsSize="sm" name="pedido" onChange={handleChange} value={tabla.pedido} />
                            </FormGroup></Col>
                        <Col md={6}>
                            <FormGroup>

                                <Label>Descripcion</Label>
                                <Input bsSize="sm" name="descripcion" onChange={handleChange} value={tabla.descripcion} />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Almacen</Label>
                                <Input bsSize="sm" type={"select"} name="almacenPorDefecto" onChange={handleChange} value={tabla.almacenPorDefecto} className="form-control"  >
                                   {/* <option value={0}>Seleccionar</option>*/}
                                    {
                                        ListadoAlmacen.map((item) => (<option key={item.almacenID} value={item.almacenID}>{item.descripcion}</option>))
                                    }

                                </Input>
                            </FormGroup></Col>

                        <Col md={2}>
                            <FormGroup>
                                <Label>Tipo Transaccion</Label>

                                <Input bsSize="sm" type={"select"} name="tipoTransaccionID" onChange={handleChange} value={tabla.tipoTransaccionID} className="form-control" >
                                    <option value={'+'}>Entrada</option>
                                    <option value={'-'}>Salida</option>
                                   

                                </Input>
                            </FormGroup>                        </Col>
                        <Col md={2}>
                            <FormGroup>

                                <Label>ITBIS ESTA INCLUIDO</Label>
                                <select id="itbisIncluido" name="itbisIncluido" onChange={handleChange} value={tabla.itbisIncluido}>
                                    <option value="0">No</option>
                                    <option value="1">Si</option>

                                </select>
                            </FormGroup></Col>
                        <Col md={4}>
                            <FormGroup>

                                <Label>Comentario</Label>
                                <Input bsSize="sm" name="comentario" onChange={handleChange} value={tabla.comentario} />
                            </FormGroup></Col>
                        <Col md={4}>
                            <FormGroup>

                                <Label>RNC</Label>
                                <Input bsSize="sm" name="rnc" onChange={handleChange} value={tabla.rnc} />
                            </FormGroup></Col>
                        <Col md={4}>
                            <FormGroup>

                                <Label>NCF</Label>
                                <Input bsSize="sm" name="ncf" onChange={handleChange} value={tabla.ncf} />
                            </FormGroup></Col>
                        <Col md={4}>
                            <FormGroup>

                                <Label>ITBIS</Label>
                                <Input bsSize="sm" name="itbis" onChange={handleChange} value={tabla.itbis} />
                            </FormGroup></Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label>subTotal</Label>
                                <Input bsSize="sm" name="subTotal" onChange={handleChange} value={tabla.subTotal} />
                            </FormGroup></Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label>Total</Label>
                                <Input bsSize="sm" name="total" onChange={handleChange} value={tabla.total} />
                            </FormGroup></Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label>FormaPago</Label>
                                <Input bsSize="sm" name="formaPago" onChange={handleChange} value={tabla.formaPago} />
                            </FormGroup></Col>
                       
                    </Row>
                    <div>
                        <Row hidden={ver}>
                        <Col md={6}>
                        <FormGroup>
                        <Label> Articulo</Label>
                                    <Select
                                        name={"articuloID"}
                                        defaultValue={options1.filter(x => x.value == tablaArt.articuloID)[0]}
                                        onChange={handleChange3}
                                        options={options1}
                                    />
                            </FormGroup>
                        </Col>
                        <Col md={1}>
                        <FormGroup>

                            <Label>cantidad</Label>
                            <Input bsSize="sm" name="cantidad" onChange={handleChange1} value={tablaArt.cantidad} />
                            </FormGroup>
                            </Col>
                            <Col md={1}>
                            <FormGroup>
                                <Label>% de Gan.</Label>
                                    <Input bsSize="sm" name="margen" onChange={handleChange2} value={margen} />
                            </FormGroup>
                            </Col>
                            <Col md={2}>
                            <FormGroup>
                                <Label>Costo</Label>
                                    <Input bsSize="sm" name="costoPromedio" onChange={handleChange2} value={tablaArt.costoPromedio} />
                            </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label>Precio</Label>
                                    <Input bsSize="sm"  onChange={(e) => Precio=(e.target.value) } value={Precio} />
                                </FormGroup>
                            </Col>
                        <Col md={2}>
                            <FormGroup>
                                <br></br>
                                    <Button hidden={ ver} size="sm" color="primary"
                            onClick={AgregarArticulo}
                        >Agregar</Button> </FormGroup></Col>
                    </Row>
                    
                        <Row>
                        <table className="table">
                            <tr>
                                <th>Articulo</th>
                                <th>Descripcion</th>
                                <th>Cantidad</th>
                                <th>Quitar</th>
                            </tr>
                                {ListadoLineas.map((x) => (
                                    <tr key={x.movimientoLineaID }>
                                    <td>{x.articuloID}</td>
                                    <td>{ListadoArticulos.filter(e => e.articuloID == x.articuloID).map(e=>e.descripcion)}</td>
                                    <td>{x.cantidad}</td>
                                    <td> <Button color="danger" size="sm"
                                        onClick={() => EliminarLinea(x.movimientoLineaID)}
                                    >
                                        <i className="fas fa-X">X</i></Button></td>
                                </tr>))}
                        </table>
                    </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button hidden={!ver } size="sm" color="primary"
                      onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                      onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
        


        </>
        )

}
export default MovimientoAlmacen;